import { render, staticRenderFns } from "./ReviewsLegalModal.vue?vue&type=template&id=3dd0113e&"
import script from "./ReviewsLegalModal.vue?vue&type=script&lang=js&"
export * from "./ReviewsLegalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports